import React from "react";
import ViewEditor from "../../components/common/ViewEditor";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw } from "draft-js";
import CheckBox from "../../components/common/form/CheckBox";
import CheckBoxInline from "../../components/common/form/CheckBoxInline";

class SubQuestionRenderer extends React.Component {
  render() {
    const {
      mainQuestion,
      index,
      qIndex,
      subQuestions,
      makeRevise,
      makeSubQuestionEdit,
      getQuestionPassageContent,
      sections
    } = this.props;

    // Extract subquestion IDs (e.g., "4,5,6")
    const subQuestionIds = mainQuestion?.sub_questions
      ? mainQuestion.sub_questions.split(',').map(id => id.trim()).filter(id => id)
      : [];

    // Parse main question content
    let mainQuestionStates = [];
    try {
      mainQuestionStates = JSON.parse(mainQuestion.content);
    } catch (e) {
      console.error("Failed to parse main question content", e);
      return null;
    }

    const mainQuestionEditor = EditorState.createWithContent(convertFromRaw(mainQuestionStates[0]));

    return (
      <div className="col-md-12" style={{ overflow: "auto" }}>
        {/* Optional passage */}
        {mainQuestion?.is_passage && mainQuestion?.passage_id && mainQuestion?.passage_content && (
          <div className="mb-5 mt-5">
            <ViewEditor editorState={getQuestionPassageContent(mainQuestion.passage_content)} />
          </div>
        )}

        {/* Main question and Mark for Review */}
        <div className="row">
          <div className="pl-2 pr-2 border border-primary rounded d-inline-block push-button">
            <CheckBoxInline>
              <CheckBox
                key={qIndex}
                onClick={(e) => makeRevise(e, qIndex)}
                checked={mainQuestion.needToRevise || false}
                checkBoxName="Mark for Review"
                style={{ color: "#5458AF" }}
              />
            </CheckBoxInline>
          </div>
          <div className="col-md-12 pt-3 mb-5">
            <div className="row">
              <div className="col-md-1 col-1 number-wrap" style={{ fontWeight: "600", fontSize: "12px", marginTop: "3px" }}>
                {index + 1}.
              </div>
              <div className="col-md-11 col-11 rdw-editor-question overflow-hidden all-questions-title" style={{ fontWeight: "600" }}>
                <ViewEditor editorState={mainQuestionEditor} />
              </div>
            </div>
          </div>
        </div>

        {/* Render subquestions using question_id */}
        {subQuestionIds.map((qidStr, j) => {
          const qid = parseInt(qidStr);
          const sub = subQuestions[qid];

          let subStates = [];
          try {
            subStates = JSON.parse(sub.content);
          } catch (e) {
            console.error(`Failed to parse content for subquestion ${qid}`, e);
            return null;
          }

          const subEditor = EditorState.createWithContent(convertFromRaw(subStates[0]));
          const subAnswer = sub.answer;

          return (
            <div className="col-md-12 ml-5 pl-5" key={`sub-${qid}`}>
              {/* Optional passage for subquestion */}
              {sub?.is_passage && sub?.passage_id && sub?.passage_content && (
                <div className="mb-5 mt-5">
                  <ViewEditor editorState={getQuestionPassageContent(sub.passage_content)} />
                </div>
              )}
              <div className="row d-flex align-items-center">
                <div className="col-md-1 col-1 number-wrap" style={{ fontSize: "12px", marginTop: "3px" }}>
                  {j + 1}.
                </div>
                {Array.isArray(sections) && sections.length > 0 && (
                  <div>
                    {sub.is_optional && (
                      <span className="badge badge-primary mr-2">Optional</span>
                    )}
                  </div>
                )}
                <div className="col-md-11 col-11 rdw-editor-question" style={{ fontWeight: "500" }}>
                  <ViewEditor editorState={subEditor} />
                </div>
              </div>

              <div className="RichEditor-root-descriptive-answer mt-3 mb-4">
                <Editor
                  placeholder="Add your answer here..."
                  editorStyle={{ maxHeight: "200px", overflow: "auto" }}
                  editorState={subAnswer}
                  onEditorStateChange={(e) => makeSubQuestionEdit(e, qid, mainQuestion.question_id)}
                  toolbar={{
                    fontFamily: {
                      options: [
                        "Arial", "Georgia", "Impact", "Tahoma", "Times New Roman", "Verdana",
                        "Kushpoo", "Baamini", "FMAbhaya"
                      ],
                    },
                  }}
                  toolbarClassName="vertical-toolbar"
                />
              </div>
              <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
            </div>
          );
        })}
      </div>
    );
  }
}

export default SubQuestionRenderer;
